import ClientIDIcon from './component'

export default ClientIDIcon
